



















import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";

@Component
export default class NaigationButtonComponent extends Vue {
    @Prop() title!: any;   

    isSelecting: boolean = false;

    onImportClick() {
        this.isSelecting = true
        window.addEventListener('focus', () => {
            this.isSelecting = false
        }, { once: true })

        //@ts-ignore
        this.$refs.uploader.click();
    }

    onAddFiles(e) {
        this.$emit('onAddFiles', e.target.files[0]);
        //@ts-ignore
        this.$refs.uploader.value=null;
    }

}

